module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "visible": _vm.visible
    },
    on: {
      "close": _vm.close
    }
  }, [_c('div', [_c('article', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-content"
  }, [_c('div', {
    staticClass: "heading"
  }, [_c('h4', [_vm._v("\n            " + _vm._s(_vm.title) + "\n          ")])]), _vm._v(" "), _c('audio-recorder', {
    attrs: {
      "attempts": 1,
      "time": 2
    },
    on: {
      "close": _vm.close,
      "confirm": _vm.confirmAction
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-497add63"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/scenarios/ModalAudio.vue
// module id = 441
// module chunks = 40